'use strict';

(() => {
  const ROTATION_DEGREES = 360;
  const ANIMATION_DURATION = 400;
  const BASE_VIEWPORT_WIDTH = 1440;
  const MIN_SCALE = 0.35;
  const iconRegistry = new Set();
  let resizeFrameId = null;

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  const ensureBaseOffset = (element, datasetKey, property) => {
    const stored = Number(element.dataset[datasetKey]);
    if (!Number.isNaN(stored)) {
      return stored;
    }

    const inlineValue = element.style.getPropertyValue(property);
    const parsedInline = inlineValue ? parseFloat(inlineValue) : 0;
    const baseValue = Number.isFinite(parsedInline) ? parsedInline : 0;

    element.dataset[datasetKey] = String(baseValue);
    return baseValue;
  };

  const applyResponsiveIconOffsets = () => {
    const viewportWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      BASE_VIEWPORT_WIDTH;

    const scale = clamp(viewportWidth / BASE_VIEWPORT_WIDTH, MIN_SCALE, 1);

    iconRegistry.forEach((icon) => {
      if (!document.contains(icon)) {
        iconRegistry.delete(icon);
        return;
      }

      const baseX = ensureBaseOffset(icon, 'iconOffsetX', '--icon-offset-x');
      const baseY = ensureBaseOffset(icon, 'iconOffsetY', '--icon-offset-y');

      icon.style.setProperty('--icon-offset-x', `${baseX * scale}px`);
      icon.style.setProperty('--icon-offset-y', `${baseY * scale}px`);
    });
  };

  const queueResponsiveUpdate = () => {
    if (resizeFrameId !== null) {
      return;
    }

    resizeFrameId = requestAnimationFrame(() => {
      resizeFrameId = null;
      applyResponsiveIconOffsets();
    });
  };

  const registerIconBlocks = (root = document) => {
    const iconBlocks = root.querySelectorAll('.banner__icon-block');
    if (!iconBlocks.length) {
      return;
    }

    iconBlocks.forEach((icon) => {
      ensureBaseOffset(icon, 'iconOffsetX', '--icon-offset-x');
      ensureBaseOffset(icon, 'iconOffsetY', '--icon-offset-y');
      iconRegistry.add(icon);
    });

    queueResponsiveUpdate();
  };

  const runIconHoverAnimation = (root = document) => {
    const buttons = root.querySelectorAll('.banner__product-add');

    buttons.forEach((button) => {
      if (button.dataset.iconHoverBound === 'true') {
        return;
      }

      const icon = button.querySelector('.banner__product-add-icon');
      if (!icon) {
        return;
      }

      const triggerSpin = () => {
        icon.animate(
          [
            { transform: 'rotate(0deg)' },
            { transform: `rotate(${ROTATION_DEGREES}deg)` }
          ],
          {
            duration: ANIMATION_DURATION,
            easing: 'ease-in-out',
            iterations: 1,
            fill: 'none'
          }
        );
      };

      button.addEventListener('mouseenter', triggerSpin);
      button.addEventListener('focus', triggerSpin);
      button.dataset.iconHoverBound = 'true';
    });
  };

  const enhanceBanner = (root = document) => {
    runIconHoverAnimation(root);
    registerIconBlocks(root);
  };

  const initialize = () => {
    enhanceBanner();
    queueResponsiveUpdate();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  window.addEventListener('resize', queueResponsiveUpdate, { passive: true });
  window.addEventListener('orientationchange', queueResponsiveUpdate, { passive: true });

  document.addEventListener('shopify:section:load', (event) => {
    enhanceBanner(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    enhanceBanner(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    iconRegistry.forEach((icon) => {
      if (event.target.contains(icon)) {
        iconRegistry.delete(icon);
      }
    });
  });
})();
